import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  Typography,
  Grow,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import PropTypes from "prop-types";

export const DeleteAgent = ({ open, onClose, onConfirm, agent }) => {
  const handleClose = () => {
    onClose?.();
  };

  const handleConfirm = () => {
    onConfirm?.();
    onClose?.();
  };

  return (
    <Dialog
      open={Boolean(open)}
      onClose={(event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
        handleClose();
      }}
      maxWidth="sm"
      fullWidth
      TransitionComponent={Grow}
      transitionDuration={300}
      disableEscapeKeyDown
    >
      <DialogContent sx={{ pt: 4 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mb: 2,
          }}
        >
          <WarningAmberIcon
            sx={{
              fontSize: 64,
              color: "warning.main",
            }}
          />
        </Box>

        <DialogContentText
          sx={{
            textAlign: "center",
            color: "text.primary",
            mb: 1,
          }}
        >
          <Typography variant="h6" component="span" sx={{ fontWeight: 600 }}>
            ¿Estás seguro que deseas eliminar este agente?
          </Typography>
        </DialogContentText>

        {agent?.display_name && (
          <DialogContentText
            sx={{
              textAlign: "center",
              color: "text.secondary",
              mb: 1,
            }}
          >
            <Typography variant="body2" component="span">
              <strong>{agent.display_name}</strong>
            </Typography>
          </DialogContentText>
        )}

        <DialogContentText
          sx={{
            textAlign: "center",
            color: "error.main",
            fontWeight: 500,
          }}
        >
          Esta acción no se podrá deshacer después.
        </DialogContentText>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3, justifyContent: "center", gap: 2 }}>
        <Button onClick={handleClose} variant="outlined" size="large">
          Cancelar
        </Button>
        <Button
          onClick={handleConfirm}
          color="error"
          variant="contained"
          size="large"
          sx={{ minWidth: 120 }}
        >
          Eliminar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DeleteAgent.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  agent: PropTypes.object,
};
